import { createStore } from 'vuex'

export default createStore({
  state: {
    navActive: "11",
  },
  getters: {
  },
  mutations: {
    changeNavActive(state,params) {
      state.navActive = params
    }
  },
  actions: {
  },
  modules: {
  }
})
